import { ApiLinkEntity, ApiLinkRel } from 'config/constants';
import AmountWithCurrency ,{ IAmountWithCurrencyDto } from 'models/AmountWithCurrency';
import { Guid, IApiLink } from "@/types"

export enum CostCategoryType {
    investment = "investment",
    sdc = "sdc",
}

export enum CostCategoryDistributionRule{
    allAssets = "allAssets",
    machineOnly = "machineOnly"
}

export interface IGetCostCategoryDto {
    costCategoryId?: Guid
    costCategoryType: CostCategoryType
    costCategoryName: string
    isFreight: boolean
    costCategoryLedgerAccount?: string | null
    hasAutomaticAssign: boolean
    automaticAssignLimit?: IAmountWithCurrencyDto
    distributionRule: CostCategoryDistributionRule
    links?: IApiLink[] | null
}

export interface ICreateCostCategoryDto {
    costCategoryType: CostCategoryType
    costCategoryName: string
    costCategoryLedgerAccount?: string | null
    hasAutomaticAssign: boolean
    automaticAssignLimit?: number | null
    distributionRule: CostCategoryDistributionRule
    isFreight?:boolean | null
}

export default class CostCategory {
    costCategoryId?: Guid
    costCategoryType: CostCategoryType
    costCategoryName: string
    costCategoryLedgerAccount?: string | null
    hasAutomaticAssign: boolean
    automaticAssignLimit?: AmountWithCurrency
    distributionRule: CostCategoryDistributionRule
    isFreight: boolean
    linkUpdate?: IApiLink

    constructor({
        costCategoryId,
        costCategoryType,
        costCategoryName,
        costCategoryLedgerAccount,
        hasAutomaticAssign,
        automaticAssignLimit,
        distributionRule,
        isFreight,
        links,
    }: IGetCostCategoryDto) {
        this.costCategoryId = costCategoryId
        this.costCategoryType = costCategoryType
        this.costCategoryName = costCategoryName
        this.costCategoryLedgerAccount = costCategoryLedgerAccount
        this.hasAutomaticAssign = hasAutomaticAssign
        this.automaticAssignLimit = automaticAssignLimit &&  new AmountWithCurrency(automaticAssignLimit)
        this.distributionRule = distributionRule
        this.isFreight= isFreight
        this.linkUpdate = links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceCostCategory && lnk.rel === ApiLinkRel.partialUpdate)
    }

    toCreateDto(): ICreateCostCategoryDto {
        return {
            costCategoryType: this.costCategoryType,
            costCategoryName: this.costCategoryName,
            costCategoryLedgerAccount: this.costCategoryLedgerAccount ?? null,
            hasAutomaticAssign: this.hasAutomaticAssign,
            automaticAssignLimit:  this.automaticAssignLimit?.amount || null,
            distributionRule: this.distributionRule,
            isFreight: this.isFreight
        }
    }
}
